import axios from "../utils/axios";

let AuthApi = {
   login: (data) => axios({
      url: '/v1/admin/login',
      method: 'post',
      data
   }),
   resetPassword: (data) => axios({
      url: '/v1/admin/reset-password',
      method: 'post',
      data
   }),
   updatePassword: (data) => axios({
      url: '/v1/admin/update-password',
      method: 'post',
      data
   }),
   register: (data) => axios({
      url: '/v1/admin/signup',
      method: 'post',
      data
   }),
   verifyAccount: (data) => axios({
      url: '/v1/admin/verify-account',
      method: 'post',
      data
   }),
   verifyOtp: (data) => axios({
      url: '/v1/admin/verify-otp',
      method: 'post',
      data
   }),

   // getMyPurchasedPackages: async () => {
   //     return await axios({
   //         url: "/v1/user/packages/purchased",
   //         method: "get",
   //         headers: {
   //             Authorization: "Bearer " + localStorage.getItem("token"),
   //         },
   //     });
   // },
}

export default AuthApi
